import React from 'react';

class DropAtStoreInfo extends React.Component {
  render() {
    return (
      <div className="dropatstore-info-wrapper">
        <div className="das-header">Drop At Store</div>
        <div className="das-subheader">You can now return item(s) directly</div>

        <div className="faq-section">
          <div className="faq-question">Why return at store?</div>
          <div className="das-features">
            <div className="feature">
              <div className="static-feature"> Faster Refunds </div>
              <div className="separator" />
              <div className="static-feature">Walk in at your convenience</div>
            </div>
          </div>
          <div className="faq-question">What do you have to do?</div>
          <ol className="das-points">
            <li>
              1. Carry the product along with its original packaging and tags to a nearby reliance
              store. Do not create any Return ID online
            </li>
            <li>
              2. Ask for an associate at the customer service desk to help you process your return
            </li>
          </ol>
        </div>
        <div className="bottom-sec">
          <div className="trends-adv">DO NOT CREATE ANY RETURNS ID ONLINE FOR RETURN AT STORE</div>
          <input type="button" value="View Stores Near Me" />
        </div>
      </div>
    );
  }
}

export default DropAtStoreInfo;
